var map = {
	"./A Winter Story.mp3": "e9cb",
	"./DSC_0154.jpg": "1291",
	"./DSC_0286_4.jpg": "c05a",
	"./DSC_0302.jpg": "54d9",
	"./DSC_0307.jpg": "51be",
	"./DSC_0319.jpg": "0797",
	"./DSC_0329.jpg": "54e3",
	"./DSC_0342.jpg": "cd1c",
	"./DSC_0342_1.jpg": "3856",
	"./DSC_1298_3.jpg": "5c34",
	"./DSC_1593.jpg": "ab64",
	"./DSC_9341.jpg": "0d21",
	"./baseline-pause-24px (1).svg": "3e2f",
	"./baseline-pause-24px.svg": "26b6",
	"./logo.png": "cf05",
	"./logo.svg": "9b19"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";